import { render, staticRenderFns } from "./CompanyTruthDeclaration.vue?vue&type=template&id=61acfb93&scoped=true&"
import script from "./CompanyTruthDeclaration.vue?vue&type=script&lang=js&"
export * from "./CompanyTruthDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTruthDeclaration.vue?vue&type=style&index=0&id=61acfb93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61acfb93",
  null
  
)

export default component.exports